<template>
  <div class="ai_home" v-auto-height="60">
    <div class="home_block1">
      <el-carousel
        class="banner-swiper"
        height="700px"
        :autoplay="false"
        arrow="never"
        indicator-position="none"
      >
        <el-carousel-item key="banner4">
          <picture>
            <source srcset="@/assets/images/banner4.webp" type="image/webp">
            <img
              class="banner-swiper__bg"
              src="@/assets/images/banner4.png"
              alt="banner4"
              width="1180"
              height="700"
              fetchpriority="high"
            >
          </picture>
          <section class="banner-swiper__content">
            <h3>腾讯音乐启明星</h3>
            <h3>AI音频发布平台</h3>
            <p>发布您的AI音频，查看管理您的音频信息</p>
            <el-button type="primary" size="large" @click="handleClick">{{ homeBtnText }}</el-button>
          </section>
        </el-carousel-item>
      </el-carousel>
    </div>

    <validate-phone :visible.sync="showValidatePhone" @bind-success="checkAccount"></validate-phone>
    <bind-platform :visible.sync="showBindPlatform" @bind-success="$store.dispatch('EnterAIHome')"></bind-platform>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import authServices from '@/api/auth'
import { getUrlParams } from '@/utils/auth'
import qimingxingMiniCode from '@/assets/images/qimingxing-mini-code.png'
import ValidatePhone from '@/components/ValidatePhone'
import BindPlatform from './components/BindPlatform'

export default {
  name: 'AiPublishIndex',
  components: {
    ValidatePhone,
    BindPlatform
  },
  data() {
    return {
      showValidatePhone: false,
      showBindPlatform: false
    }
  },
  computed: {
    ...mapGetters(['hasLogin', 'userInfo', 'notRegister']),

    /**
     * @returns{String}
     */
    homeBtnText() {
      return this.notRegister ? '用户入驻' : '用户中心'
    },
    notBoundPlatform() {
      return !this.userInfo.hasBindPlatform
    }
  },
  watch: {
    hasLogin: {
      immediate: true,
      async handler(val) {
        if (val) {
          // 登录后检查酷狗绑定回调
          const { code, redirect_type: redirectType } = getUrlParams()
          if (code && redirectType === 'kg_bind') {
            history.replaceState(null, '', `${location.origin}${location.pathname}`)
            await this.bindKGAccount(code)
            await this.$store.dispatch('GetInfo')
            this.$store.dispatch('EnterAIHome')
          } else {
            this.checkAccount()
          }
        }
      }
    }
  },
  created() {
    const h = this.$createElement
    this.$msgbox({
      title: '温馨提示',
      message: h('div', null, [
        h('p', null, '腾讯音乐启明星·AI音频发布平台为个人上传AI音频作品的唯一官方渠道，上传AI音频的整个流程中不会收取任何费用。请提高警惕，不轻信陌生信息，谨防诈骗。如遇到类似情况，可通过本平台首页反馈功能或扫描启明星客服二维码进行反馈。 '),
        h('img', { attrs: { src: qimingxingMiniCode }, style: 'width: 200px; height: 200px; margin: 30px 0;' })
      ]),
      customClass: 'warning-msgbox',
      confirmButtonText: '确定',
      showCancelButton: false,
      center: true,
    })
  },
  methods: {
    checkAccount() {
      if (!this.userInfo.phoneNum) {
        this.showValidatePhone = true
        return false
      } else if (this.notBoundPlatform) {
        this.showBindPlatform = true
        return false
      }

      return true
    },
    handleClick() {
      if (this.hasLogin) {
        this.checkAccount() && this.$store.dispatch('EnterAIHome')
      } else {
        this.$store.commit('login', true)
      }
    },

    async bindKGAccount(code) {
      try {
        await authServices.bindKGAccount({ code })
        this.$message.success('酷狗音乐绑定成功')
      } catch (error) {
        this.$message.error(`酷狗音乐绑定失败.${error.message}`)
      }
    },
  }
}
</script>

<style lang="scss">
.ai_home {
  overflow-y: auto;
  background-color: #000;
  background: linear-gradient(8.55deg, #001D48 6.16%, #000000 92.47%);
  display: flex;
  flex-direction: column;
  color: #fff;

  ::v-deep {
    .el-carousel__arrow {
      background-color: transparent;

      .el-icon-arrow-left, .el-icon-arrow-right {
        font-size: 32px;
      }
    }

    .el-carousel__indicator {
      position: relative;
      width: 63px;
      height: 10px;
      padding: 0;
      border-radius: 24px;
      background: #FFFFFF1F;

      &:not(:first-child) {
        margin-left: 20px;
      }

      .el-carousel__button {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 24px;
      }

      &.is-active {
        width: 118px;
        background-color: #fff;
      }
    }
  }

  .home_block1 {
    flex-grow: 1;
    width: 100%;
    overflow: hidden;

    .banner-swiper {
      height: 700px;

      &__bg {
        margin-left: 40%;
        object-fit: cover;
        position: absolute;
        top: 0;
        z-index: -1;
      }

      &__content {
        position: relative;
        z-index: 1;
        width: 1200px;
        margin: 80px auto 0;

        h3 {
          font-size: 54px;
          font-weight: bold;
          line-height: 80px;
        }

        p {
          // max-width: 730px;
          margin-top: 30px;
          font-size: 27px;
          font-weight: bold;
          line-height: 40px;
        }

        button {
          margin-top: 65px;
          width: 150px;
          height: 54px;
          font-size: 24px;
        }
      }
    }
  }
}

.warning-msgbox {
  position: absolute;
  top: 15vh;
  left: 50%;
  transform: translateX(-50%);
}
</style>
